import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import React__default, { useRef, useMemo, useCallback, useEffect } from 'react';
import { VariableSizeList } from 'react-window';
import useScrollCapture from '../../../hooks/useScrollCapture/useScrollCapture.js';
import 'react-highlight-words';
import useShadowStyle from '../hooks/useShadowStyle.js';

const ListItem = styled('span') `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  :last-of-type {
    #bottomDivider {
      display: none;
    }
    justify-content: flex-start;
  }
`;
// eslint-disable-next-line react/display-name
const InnerElement = React__default.forwardRef((props, ref) => (jsx("div", Object.assign({ ref: ref }, props, { onMouseDown: e => {
        //@ts-ignore
        e.target.parentElement.parentElement.parentElement.click();
    } }))));
const SCROLL_WIDTH = 14;
function VirtualizedMenuList(_a) {
    var { children, maxHeight, innerProps, withTopShadow, withBottomShadow, className = '', selectProps, getValue, getItemSize, isMulti, baseItemHeight } = _a, rest = __rest(_a, ["children", "maxHeight", "innerProps", "withTopShadow", "withBottomShadow", "className", "selectProps", "getValue", "getItemSize", "isMulti", "baseItemHeight"]);
    const { scrollRef, scrollPosition } = useScrollCapture(true);
    const shadowStyle = useShadowStyle(scrollPosition, withTopShadow, withBottomShadow);
    const [value] = getValue();
    const { options: selectOptions, closeMenuOnSelect, onMenuClose } = selectProps;
    const listRef = useRef(null);
    const itemCount = useMemo(() => children.length || 1, [children]);
    const innerGetItemSize = useCallback(index => {
        let size = baseItemHeight;
        if (getItemSize) {
            size = getItemSize(index);
        }
        return size;
    }, [baseItemHeight, getItemSize]);
    const listHeight = useMemo(() => {
        let itemsSizes = 0;
        for (let index = 0; index < itemCount; index++) {
            itemsSizes += innerGetItemSize(index);
            if (itemsSizes > maxHeight + 8) {
                return maxHeight;
            }
        }
        return itemsSizes;
    }, [itemCount, maxHeight, innerGetItemSize]);
    useEffect(() => {
        if (listRef.current && value && !isMulti) {
            // @ts-ignore
            const valueIndex = selectOptions.findIndex(item => item.value === value.value);
            listRef.current.scrollToItem(valueIndex, 'start');
        }
    }, [isMulti, selectOptions, value]);
    useEffect(() => {
        if (listRef.current) {
            listRef.current.resetAfterIndex(0);
        }
    }, [children]);
    const onItemClick = useCallback(() => {
        if (closeMenuOnSelect) {
            setTimeout(() => {
                onMenuClose();
            }, 0);
        }
        // NOTE: This eslint warning was disabled in order to enable a pre-push hook. It doesn't mean that the warning isn't
        // valid. Whoever touches this code, please try removing the eslint-disable-next-line comment and fix the problem.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderItem = useCallback(({ index, style }) => (jsx(ListItem, Object.assign({ style: style, onClick: onItemClick }, { children: children[index] || children }))), 
    // NOTE: This eslint warning was disabled in order to enable a pre-push hook. It doesn't mean that the warning isn't
    // valid. Whoever touches this code, please try removing the eslint-disable-next-line comment and fix the problem.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [children]);
    return (jsx(VariableSizeList, Object.assign({ width: "100%", height: listHeight, itemCount: itemCount, itemSize: innerGetItemSize, className: `react-select_menuList ${className}`, outerRef: scrollRef, ref: listRef, style: Object.assign(Object.assign(Object.assign({}, innerProps === null || innerProps === void 0 ? void 0 : innerProps.style), shadowStyle), { overflow: 'auto overlay', paddingRight: SCROLL_WIDTH }), innerElementType: InnerElement }, rest, { children: renderItem })));
}

export { VirtualizedMenuList as default };
//# sourceMappingURL=VirtualizedMenuList.js.map
